export default {
  error_messages: {
    orders_disabled: 'Order here currently not possible',
  },
};
